import React, { Component } from 'react';
import Dropdownmenu from './components/dropdown-menu/Dropdownmenu';
import Auxbrowserfunc from './components/aux-browser-func/Auxbrowserfunc';
import Mobilemenu from './components/mobile-menu/Mobilemenu';
import Setlangfunc from './components/set-lang-func/Setlangfunc';
// import Mycart from './Mycart';
// import Cartbasket from './components/cart/cart-basket/Cartbasket';
//import Playonview from './components/play-on-view/Playonview';

import './App.css';

class App extends Component {
  /**
   * window.location.href
   * returns the href (URL) of the current page
   * window.location.hostname returns the domain name of the web host
   * window.location.pathname returns the path and filename of the current page
   * window.location.protocol returns the web protocol used (http: or https:)
   */
  // conditional return based on url
  // const currenturl = window.location.href;

  componentDidMount() {
    window.document.getElementsByClassName('accordion').onclick = function(e) {
      
    }

    this.initialize()
  }


  initialize = () => {    
        
    let userSelection = document.getElementsByClassName('accordion');
    let userSelectionAns = document.getElementsByClassName('faq-answer');

    for(let i = 0; i < userSelection.length; i++) {
      (function(index) {
        userSelection[index].addEventListener("click", function(e) {
          e.preventDefault()
          //console.log(`Clicked index: ${index} event: ${e}`);          
          userSelection[index].classList.toggle("active");          
          userSelectionAns[index].classList.toggle('active');
         })
      })(i);
    }

  };

  faqAccordion = (e) => {
    // console.log('clicked')
      e.preventDefault()
      this.toggleClass("active")
      this.next().toggleClass("active")
  }


  render() {    
    return (
      <div className="App">
        <Dropdownmenu />
        <Auxbrowserfunc />
        <Mobilemenu />        
        <Setlangfunc />        
      </div>
    );
  }
}

export default App;
